import React, {
  createContext,
  useEffect,
  useReducer,
  useState
} from 'react';
import jwtDecode from 'jwt-decode';
import SplashScreen from 'src/components/loaders/loading';
import axios from 'src/utils/axios';
import toast from "react-hot-toast"
import { checkForSurvery1, checkForSurvery2 } from 'src/utils/checkForSurveyNumber';

const initialAuthState = {
  isAuthenticated: false,
  isInitialised: false,
  user: null
};

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'INITIALISE': {
      const { isAuthenticated, user } = action.payload;

      return {
        ...state,
        isAuthenticated,
        isInitialised: true,
        user
      };
    }
    case 'LOGIN': {
      const { user } = action.payload;

      return {
        ...state,
        isAuthenticated: true,
        user
      };
    }
    case 'LOGOUT': {
      return {
        ...state,
        isAuthenticated: false,
        user: null
      };
    }
    case 'REGISTER': {
      const { user } = action.payload;

      return {
        ...state,
        isAuthenticated: true,
        user
      };
    }
    default: {
      return { ...state };
    }
  }
};

const AuthContext = createContext({
  ...initialAuthState,
  method: 'JWT',
  login: () => Promise.resolve(),
  logout: () => { },
  register: () => Promise.resolve()
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialAuthState);
  const [showGroupOverview, setShowGroupOverview] = useState(false)
  const [toggleNav, setToggleNav] = useState(false)
  const [languageToggler, setLanguageToggler] = useState(false)
  const [groups, setGroups] = useState([])
  const [answers, setAnswers] = useState([])
  const [groupSurveys, setGroupSurveys] = useState([])
  const [showGroupDropDown, setshowGroupDropDown] = useState(false)
  const [groupId, setGroupId] = useState(null)
  const [toggler, setToggler] = useState(false)
  const [globalLoading, setGlobalLoading] = useState(false)
  const selected_language = localStorage.getItem("lang")

  // Calculations
  const [surveyOnequestions, setSurveyOneQuestions] = useState([])
  const [surveyTwoquestions, setSurveyTwoQuestions] = useState([])

  const [selfAwarenessSum1, setSelfAwarenessSum1] = useState(null)
  const [selfAwarenessSum2, setSelfAwarenessSum2] = useState(null)
  const [eductionSum1, setEductionSum1] = useState(null)
  const [eductionSum2, setEductionSum2] = useState(null)
  const [socialAwarenessSum1, setSocialAwarenessSum1] = useState(null)
  const [socialAwarenessSum2, setSocialAwarenessSum2] = useState(null)

  const eduction = [3, 4, 15, 18, 20, 21, 22, 23]
  const social_awareness = [7, 11, 13, 14, 16, 17]
  const self_awareness = [2, 5, 6, 8, 9, 10, 12, 19]

  let surveyOneEducationSum = 0
  let surveyOneSocialAwarenessSum = 0
  let surveyOneSelfAwarenessSum = 0

  let surveyTwoEducationSum = 0
  let surveyTwoSocialAwarenessSum = 0
  let surveyTwoSelfAwarenessSum = 0

  const sortAnswers = () => {

    const surveyOne = []
    const surveyOneEighteenOnwards = []

    const surveyTwo = []
    const surveyTwoEighteenOnwards = []
    const surveyTwoTwentyThreeOnwards = []

    answers.forEach(answer => {
      
      // if (answer.SURVEYNAME === "Skills4Life1") {
      if (checkForSurvery1(answer.TITLE)) {

        let pointsCalculation

        if (Number(answer.question.substring(0, 2)) === 16) {
          pointsCalculation = 100 - (Number(answer.VALUE) - 1) * 25
        }

        if (Number(answer.question.substring(0, 2)) === 17) {
          pointsCalculation = (Number(answer.VALUE) - 1) * 25
        }

        if (Number(answer.question.substring(0, 2)) !== 17 && Number(answer.question.substring(0, 2)) !== 16) {
          pointsCalculation = answer.POINTS
        }

        if (Number(answer.question.substring(0, 2)) !== 18 && Number(answer.question.substring(0, 2)) !== 19 && Number(answer.question.substring(0, 2)) !== 20 && Number(answer.question.substring(0, 2)) !== 21 && Number(answer.question.substring(0, 2)) !== 22 && Number(answer.question.substring(0, 2)) !== 23) {
          surveyOne.push({ question: answer.question, points: pointsCalculation, value: answer.VALUE, title: answer.ETITLE, Answer_set: answer.AS_ID, selectedAnswer: answer.ETITLE })
        }


        if (Number(answer.question.substring(0, 2)) == 18 || Number(answer.question.substring(0, 2)) == 19 || Number(answer.question.substring(0, 2)) == 20 || Number(answer.question.substring(0, 2)) == 21 || Number(answer.question.substring(0, 2)) == 22 || Number(answer.question.substring(0, 2)) == 23) {
          surveyOneEighteenOnwards.push({ question: answer.question, points: pointsCalculation, value: answer.VALUE, title: answer.ETITLE, Answer_set: answer.AS_ID, selectedAnswer: answer.ETITLE })
        }
      }

      // if (answer.SURVEYNAME === "Skills4Life2") {
      if (checkForSurvery2(answer.TITLE)) {

        let pointsCalculation

        if (Number(answer.question.substring(0, 2)) === 16) {
          pointsCalculation = 100 - (Number(answer.VALUE) - 1) * 25
        }

        if (Number(answer.question.substring(0, 2)) === 17) {
          pointsCalculation = (Number(answer.VALUE) - 1) * 25
        }

        if (Number(answer.question.substring(0, 2)) !== 17 && Number(answer.question.substring(0, 2)) !== 16) {
          pointsCalculation = answer.POINTS
        }

        if (Number(answer.question.substring(0, 2)) !== 18 && Number(answer.question.substring(0, 2)) !== 19 && Number(answer.question.substring(0, 2)) !== 20 && Number(answer.question.substring(0, 2)) !== 21 && Number(answer.question.substring(0, 2)) !== 22 && Number(answer.question.substring(0, 2)) !== 23 && answer.question !== "My satisfaction:" && answer.question !== "My assessment:") {
          surveyTwo.push({ question: answer.question, points: pointsCalculation, value: answer.VALUE, title: answer.ETITLE, Answer_set: answer.AS_ID, selectedAnswer: answer.ETITLE })
        }

        if (Number(answer.question.substring(0, 2)) == 18 || Number(answer.question.substring(0, 2)) == 19 || Number(answer.question.substring(0, 2)) == 20 || Number(answer.question.substring(0, 2)) == 21 || Number(answer.question.substring(0, 2)) == 22 || Number(answer.question.substring(0, 2)) == 23) {
          surveyTwoEighteenOnwards.push({ question: answer.question, points: pointsCalculation, value: answer.VALUE, title: answer.ETITLE, Answer_set: answer.AS_ID, selectedAnswer: answer.ETITLE })
        }

        if (answer.question === "My satisfaction:" || answer.question === "My assessment:") {
          surveyTwoTwentyThreeOnwards.push({ question: answer.question, points: pointsCalculation, value: answer.VALUE, title: answer.ETITLE, Answer_set: answer.AS_ID, selectedAnswer: answer.ETITLE })
        }
      }
    });

    if (surveyOne.length) {

      let keysOne = ['question'],
        countOne = {},
        resultOne = surveyOne.reduce(function (r, o) {
          let key = keysOne.map(function (k) { return o[k]; })
          if (!countOne[key]) {
            countOne[key] = { sum: +o.points, data: JSON.parse(JSON.stringify(o)) };
            countOne[key].data.groupAverage = +o.points
            countOne[key].data.count = 1;
            r.push(countOne[key].data);
          } else {
            countOne[key].sum += +o.points;
            countOne[key].data.point = countOne[key].sum
            countOne[key].data.groupAverage = (countOne[key].sum / ++countOne[key].data.count).toFixed(2)
          }
          return r;
        }, []);

      if (surveyOneEighteenOnwards.length) {

        let keysOne = ['Answer_set', 'question'],
          countOne = {},
          resultOneEighteenOnwards = surveyOneEighteenOnwards.reduce(function (r, o) {
            let key = keysOne.map(function (k) { return o[k]; })
            if (!countOne[key]) {
              countOne[key] = { sum: +o.points, data: JSON.parse(JSON.stringify(o)) };
              countOne[key].data.groupAverage = +o.points
              countOne[key].data.count = 1;
              const number = countOne[key].data.question.split(".")[0]
              countOne[key].data.number = Number(number)


              if (number == 18) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

              }
              if (number == 19) {

                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "at any age" && countOne[key].data.selectedAnswer !== 0) {
                  countOne[key].data.universalValue = 100
                }

              }

              if (number == 20) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "taxi driver" || countOne[key].data.selectedAnswer == "cashier") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 21) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "mental health counsellor" || countOne[key].data.selectedAnswer == "drone pilot" || countOne[key].data.selectedAnswer == "biofuel farmer") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 22) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "creative thinking" || countOne[key].data.selectedAnswer == "collaboration" || countOne[key].data.selectedAnswer == "perseverance" || countOne[key].data.selectedAnswer == "empathy" || countOne[key].data.selectedAnswer == "learning to learn") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 23) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "organisational skills" || countOne[key].data.selectedAnswer == "problem solving" || countOne[key].data.selectedAnswer == "listening" || countOne[key].data.selectedAnswer == "leadership") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }


              r.push(countOne[key].data);
            } else {

              const number = countOne[key].data.question.split(".")[0]

              if (number == 18) {

                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

              }

              if (number == 19) {

                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "at any age" && countOne[key].data.selectedAnswer !== 0) {
                  countOne[key].data.universalValue = 100
                }

              }

              if (number == 20) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "taxi driver" || countOne[key].data.selectedAnswer == "cashier") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 21) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "mental health counsellor" || countOne[key].data.selectedAnswer == "drone pilot" || countOne[key].data.selectedAnswer == "biofuel farmer") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 22) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "creative thinking" || countOne[key].data.selectedAnswer == "collaboration" || countOne[key].data.selectedAnswer == "perseverance" || countOne[key].data.selectedAnswer == "empathy" || countOne[key].data.selectedAnswer == "learning to learn") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 23) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "organisational skills" || countOne[key].data.selectedAnswer == "problem solving" || countOne[key].data.selectedAnswer == "listening" || countOne[key].data.selectedAnswer == "leadership") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              countOne[key].sum += +o.points;
              countOne[key].data.point = countOne[key].sum
              ++countOne[key].data.count
              countOne[key].data.groupAverage += countOne[key].data.groupAverage
              countOne[key].data.number = Number(number)


            }
            return r;
          }, []);

        resultOneEighteenOnwards.forEach((result) => {

          if (result.universalValue !== undefined) {
            result.groupAverage = result.universalValue
          } else {

            if (result.number == 18) {
              if (result.count == 1 || result.count == 2) result.groupAverage = 25
              if (result.count == 3 || result.count == 4) result.groupAverage = 50
              if (result.count == 5) result.groupAverage = 75
              if (result.count == 6 || result.count > 6) result.groupAverage = 100
            }

            if (result.number == 19) {
              if (result.count == 1 || result.count == 2 || result.count == 3) result.groupAverage = 50
              if (result.count == 4 || result.count > 4) result.groupAverage = 75
            }

            if (result.number == 20) {
              if (!result.wrongAnswerCount) result.wrongAnswerCount = 0
              if (!result.rightAnswerCount) result.rightAnswerCount = 0

              if (result.wrongAnswerCount > result.rightAnswerCount) result.groupAverage = 25
              if (result.rightAnswerCount >= result.wrongAnswerCount) result.groupAverage = 50
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 1) result.groupAverage = 75
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 2) result.groupAverage = 100
            }

            if (result.number == 21) {
              if (!result.wrongAnswerCount) result.wrongAnswerCount = 0
              if (!result.rightAnswerCount) result.rightAnswerCount = 0

              if (result.wrongAnswerCount > result.rightAnswerCount) result.groupAverage = 0
              if (result.rightAnswerCount >= result.wrongAnswerCount) result.groupAverage = 25
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 1) result.groupAverage = 50
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 2) result.groupAverage = 75
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 3) result.groupAverage = 100
            }

            if (result.number == 22) {
              if (!result.wrongAnswerCount) result.wrongAnswerCount = 0
              if (!result.rightAnswerCount) result.rightAnswerCount = 0

              if (result.wrongAnswerCount > result.rightAnswerCount) result.groupAverage = 0
              if (result.rightAnswerCount >= result.wrongAnswerCount) result.groupAverage = 25
              if (result.wrongAnswerCount == 0 && (result.rightAnswerCount == 1 || result.rightAnswerCount == 2)) result.groupAverage = 50
              if (result.wrongAnswerCount == 0 && (result.rightAnswerCount == 3 || result.rightAnswerCount == 4)) result.groupAverage = 75
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 5) result.groupAverage = 100
            }

            if (result.number == 23) {
              if (!result.wrongAnswerCount) result.wrongAnswerCount = 0
              if (!result.rightAnswerCount) result.rightAnswerCount = 0

              if (result.wrongAnswerCount > result.rightAnswerCount) result.groupAverage = 0
              if (result.rightAnswerCount >= result.wrongAnswerCount) result.groupAverage = 25
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 1) result.groupAverage = 50
              if (result.wrongAnswerCount == 0 && (result.rightAnswerCount == 2 || result.rightAnswerCount == 3)) result.groupAverage = 75
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 4) result.groupAverage = 100
            }

          }

        })

        if (resultOneEighteenOnwards.length) {

          let keysOne = ['number'],
            countOne = {},
            resultOneModified = resultOneEighteenOnwards.reduce(function (r, o) {
              let key = keysOne.map(function (k) { return o[k]; })
              if (!countOne[key]) {
                countOne[key] = { sum: +o.groupAverage, data: JSON.parse(JSON.stringify(o)) };
                countOne[key].data.groupAverage = +o.groupAverage
                countOne[key].data.count = 1;
                r.push(countOne[key].data);
              } else {
                countOne[key].sum += +o.groupAverage;
                countOne[key].data.groupAverage = (countOne[key].sum / ++countOne[key].data.count).toFixed(2)
              }
              return r;
            }, []);

          const combinedArray = [...resultOne, ...resultOneModified]


          setSurveyOneQuestions(combinedArray)
        }

      }

    }

    if (surveyTwo.length) {

      let keysTwo = ['question'],
        countOne = {},
        resultTwo = surveyTwo.reduce(function (r, o) {
          let key = keysTwo.map(function (k) { return o[k]; })
          if (!countOne[key]) {
            countOne[key] = { sum: +o.points, data: JSON.parse(JSON.stringify(o)) };
            countOne[key].data.groupAverage = +o.points
            countOne[key].data.count = 1;
            r.push(countOne[key].data);
          } else {
            countOne[key].sum += +o.points;
            countOne[key].data.point = countOne[key].sum
            countOne[key].data.groupAverage = (countOne[key].sum / ++countOne[key].data.count).toFixed(2)
          }
          return r;
        }, []);

      if (surveyTwoEighteenOnwards.length) {

        let keysTwo = ['Answer_set', 'question'],
          countOne = {},
          resultTwoEighteenOnwards = surveyTwoEighteenOnwards.reduce(function (r, o) {
            let key = keysTwo.map(function (k) { return o[k]; })
            if (!countOne[key]) {
              countOne[key] = { sum: +o.points, data: JSON.parse(JSON.stringify(o)) };
              countOne[key].data.groupAverage = +o.points
              countOne[key].data.count = 1;
              const number = countOne[key].data.question.split(".")[0]
              countOne[key].data.number = Number(number)


              if (number == 18) {

                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

              }
              if (number == 19) {

                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "at any age" && countOne[key].data.selectedAnswer !== 0) {
                  countOne[key].data.universalValue = 100
                }

              }

              if (number == 20) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "taxi driver" || countOne[key].data.selectedAnswer == "cashier") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 21) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "mental health counsellor" || countOne[key].data.selectedAnswer == "drone pilot" || countOne[key].data.selectedAnswer == "biofuel farmer") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 22) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "creative thinking" || countOne[key].data.selectedAnswer == "collaboration" || countOne[key].data.selectedAnswer == "perseverance" || countOne[key].data.selectedAnswer == "empathy" || countOne[key].data.selectedAnswer == "learning to learn") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 23) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "organisational skills" || countOne[key].data.selectedAnswer == "problem solving" || countOne[key].data.selectedAnswer == "listening" || countOne[key].data.selectedAnswer == "leadership") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              r.push(countOne[key].data);
            } else {

              const number = countOne[key].data.question.split(".")[0]

              if (number == 18) {

                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

              }

              if (number == 19) {

                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "at any age" && countOne[key].data.selectedAnswer !== 0) {
                  countOne[key].data.universalValue = 100
                }

              }

              if (number == 20) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "taxi driver" || countOne[key].data.selectedAnswer == "cashier") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 21) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "mental health counsellor" || countOne[key].data.selectedAnswer == "drone pilot" || countOne[key].data.selectedAnswer == "biofuel farmer") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 22) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "creative thinking" || countOne[key].data.selectedAnswer == "collaboration" || countOne[key].data.selectedAnswer == "perseverance" || countOne[key].data.selectedAnswer == "empathy" || countOne[key].data.selectedAnswer == "learning to learn") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              if (number == 23) {
                if (countOne[key].data.selectedAnswer == "don’t know") {
                  countOne[key].data.universalValue = 0
                }

                if (countOne[key].data.selectedAnswer == "organisational skills" || countOne[key].data.selectedAnswer == "problem solving" || countOne[key].data.selectedAnswer == "listening" || countOne[key].data.selectedAnswer == "leadership") {
                  if (countOne[key].data.rightAnswerCount) {
                    countOne[key].data.rightAnswerCount += 1
                  } else {
                    countOne[key].data.rightAnswerCount = 1
                  }
                } else {
                  if (countOne[key].data.wrongAnswerCount) {
                    countOne[key].data.wrongAnswerCount += 1
                  } else {
                    countOne[key].data.wrongAnswerCount = 1
                  }
                }
              }

              countOne[key].sum += +o.points;
              countOne[key].data.point = countOne[key].sum
              ++countOne[key].data.count
              countOne[key].data.groupAverage += countOne[key].data.groupAverage
              countOne[key].data.number = Number(number)

            }
            return r;
          }, []);

        resultTwoEighteenOnwards.forEach((result) => {

          if (result.universalValue !== undefined) {
            result.groupAverage = result.universalValue
          } else {

            if (result.number == 18) {
              if (result.count == 1 || result.count == 2) result.groupAverage = 25
              if (result.count == 3 || result.count == 4) result.groupAverage = 50
              if (result.count == 5) result.groupAverage = 75
              if (result.count == 6 || result.count > 6) result.groupAverage = 100
            }

            if (result.number == 19) {
              if (result.count == 1 || result.count == 2 || result.count == 3) result.groupAverage = 50
              if (result.count == 4 || result.count > 4) result.groupAverage = 75
            }

            if (result.number == 20) {
              if (!result.wrongAnswerCount) result.wrongAnswerCount = 0
              if (!result.rightAnswerCount) result.rightAnswerCount = 0

              if (result.wrongAnswerCount > result.rightAnswerCount) result.groupAverage = 25
              if (result.rightAnswerCount >= result.wrongAnswerCount) result.groupAverage = 50
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 1) result.groupAverage = 75
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 2) result.groupAverage = 100
            }

            if (result.number == 21) {
              if (!result.wrongAnswerCount) result.wrongAnswerCount = 0
              if (!result.rightAnswerCount) result.rightAnswerCount = 0

              if (result.wrongAnswerCount > result.rightAnswerCount) result.groupAverage = 0
              if (result.rightAnswerCount >= result.wrongAnswerCount) result.groupAverage = 25
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 1) result.groupAverage = 50
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 2) result.groupAverage = 75
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 3) result.groupAverage = 100
            }

            if (result.number == 22) {
              if (!result.wrongAnswerCount) result.wrongAnswerCount = 0
              if (!result.rightAnswerCount) result.rightAnswerCount = 0

              if (result.wrongAnswerCount > result.rightAnswerCount) result.groupAverage = 0
              if (result.rightAnswerCount >= result.wrongAnswerCount) result.groupAverage = 25
              if (result.wrongAnswerCount == 0 && (result.rightAnswerCount == 1 || result.rightAnswerCount == 2)) result.groupAverage = 50
              if (result.wrongAnswerCount == 0 && (result.rightAnswerCount == 3 || result.rightAnswerCount == 4)) result.groupAverage = 75
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 5) result.groupAverage = 100
            }

            if (result.number == 23) {
              if (!result.wrongAnswerCount) result.wrongAnswerCount = 0
              if (!result.rightAnswerCount) result.rightAnswerCount = 0

              if (result.wrongAnswerCount > result.rightAnswerCount) result.groupAverage = 0
              if (result.rightAnswerCount >= result.wrongAnswerCount) result.groupAverage = 25
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 1) result.groupAverage = 50
              if (result.wrongAnswerCount == 0 && (result.rightAnswerCount == 2 || result.rightAnswerCount == 3)) result.groupAverage = 75
              if (result.wrongAnswerCount == 0 && result.rightAnswerCount == 4) result.groupAverage = 100
            }

          }

        })

        if (resultTwoEighteenOnwards.length) {

          let keysOne = ['number'],
            countOne = {},
            resultTwoModified = resultTwoEighteenOnwards.reduce(function (r, o) {
              let key = keysOne.map(function (k) { return o[k]; })
              if (!countOne[key]) {
                countOne[key] = { sum: +o.groupAverage, data: JSON.parse(JSON.stringify(o)) };
                countOne[key].data.groupAverage = +o.groupAverage
                countOne[key].data.count = 1;
                r.push(countOne[key].data);
              } else {
                countOne[key].sum += +o.groupAverage;
                countOne[key].data.groupAverage = (countOne[key].sum / ++countOne[key].data.count)
              }
              return r;
            }, []);

          const combinedArrayTwo = [...resultTwo, ...resultTwoModified, ...surveyTwoTwentyThreeOnwards]

          setSurveyTwoQuestions(combinedArrayTwo)
        }

      }

    }

  }


  const total = () => {

    surveyOnequestions.forEach(element => {
      if (eduction.includes(Number(element.question.substring(0, 2)))) {
        surveyOneEducationSum += Number(element.groupAverage)
        let educationAverage = surveyOneEducationSum / eduction.length
        setEductionSum1(educationAverage.toFixed(2))
      }
      if (social_awareness.includes(Number(element.question.substring(0, 2)))) {
        surveyOneSocialAwarenessSum += Number(element.groupAverage)
        let socialAverage = surveyOneSocialAwarenessSum / social_awareness.length
        setSocialAwarenessSum1(socialAverage.toFixed(2))
      }
      if (self_awareness.includes(Number(element.question.substring(0, 2)))) {
        surveyOneSelfAwarenessSum += Number(element.groupAverage)
        let selfAverage = surveyOneSelfAwarenessSum / self_awareness.length
        setSelfAwarenessSum1(selfAverage.toFixed(2))
      }
    });

    surveyTwoquestions.forEach(element => {
      if (eduction.includes(Number(element.question.substring(0, 2)))) {
        surveyTwoEducationSum += Number(element.groupAverage)
        let educationAverage = surveyTwoEducationSum / eduction.length
        setEductionSum2(educationAverage.toFixed(2))
      }
      if (social_awareness.includes(Number(element.question.substring(0, 2)))) {
        surveyTwoSocialAwarenessSum += Number(element.groupAverage)
        let socialAverage = surveyTwoSocialAwarenessSum / social_awareness.length
        setSocialAwarenessSum2(socialAverage.toFixed(2))
      }
      if (self_awareness.includes(Number(element.question.substring(0, 2)))) {
        surveyTwoSelfAwarenessSum += Number(element.groupAverage)
        let selfAverage = surveyTwoSelfAwarenessSum / self_awareness.length
        setSelfAwarenessSum2(selfAverage.toFixed(2))
      }
    });
  }

  // Calculation End

  const handleGroupOverviewToggle = (id) => {
    setGroupId(id)
    setshowGroupDropDown(!showGroupDropDown)
  }

  const getGroups = async () => {
    const { data } = await axios.get(`${process.env.REACT_APP_PORT}/api/groups/get/${state.user.id}`)
    if (!data.success) return toast.error(data.message)
    setGroupSurveys(data.groupSurveys)
    setGroups(data.groups)
  }

  const getAnswers = async (code) => {
    const { data } = await axios.get(`${process.env.REACT_APP_PORT}/api/calculation/get/${code}`)
    if (!data.success) return toast.error(data.message)
    setAnswers(data.answers)
  }

  const login = async ({ email, password }) => {

    const response = await axios.post(`${process.env.REACT_APP_PORT}/api/auth/login`, { email, password });
    const { accessToken, user } = response.data;

    setSession(accessToken);

    if (!response.data.success) return response

    dispatch({
      type: 'LOGIN',
      payload: {
        user
      }
    });

    return response
  };

  const loginWithSocialMedia = async ({ email, displayName }) => {

    const response = await axios.post(`${process.env.REACT_APP_PORT}/api/auth/social-login`, { email, displayName })

    const { accessToken, user } = response.data;

    setSession(accessToken);

    console.log(response.data , "response.data.success")

    if (!response.data.success) return response

    dispatch({
      type: 'LOGIN',
      payload: {
        user
      }
    });

    return response
  }

  const logout = () => {
    setSession(null);
    dispatch({ type: 'LOGOUT' });
  };

  const register = async ({ email, full_name, password }) => {

    const response = await axios.post(`${process.env.REACT_APP_PORT}/api/auth/register`, {
      email,
      full_name,
      password,
      selected_language
    });

    const { success, message } = response.data;

    return {
      success,
      message
    }

  };

  useEffect(() => {
    const initialise = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');

        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);

          const response = await axios.post(`${process.env.REACT_APP_PORT}/api/auth/verify`);
          const { user } = response.data;

          dispatch({
            type: 'INITIALISE',
            payload: {
              isAuthenticated: true,
              user
            }
          });
        } else {
          dispatch({
            type: 'INITIALISE',
            payload: {
              isAuthenticated: false,
              user: null
            }
          });
        }
      } catch (err) {
        dispatch({
          type: 'INITIALISE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
      }
    };

    initialise();
  }, []);

  if (!state.isInitialised) {
    return <SplashScreen />;
  }

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'JWT',
        login,
        logout,
        register,
        loginWithSocialMedia,
        showGroupOverview,
        setShowGroupOverview,
        toggleNav,
        setToggleNav,
        languageToggler,
        setLanguageToggler,
        getGroups,
        groupSurveys,
        groups,
        setGroups,
        groupId,
        showGroupDropDown,
        handleGroupOverviewToggle,
        toggler, setToggler,
        globalLoading, setGlobalLoading,
        selected_language,

        getAnswers,
        answers,

        surveyOnequestions,
        surveyTwoquestions,
        setSurveyOneQuestions,
        setSurveyTwoQuestions,

        selfAwarenessSum1, setSelfAwarenessSum1,
        selfAwarenessSum2, setSelfAwarenessSum2,
        eductionSum1, setEductionSum1,
        eductionSum2, setEductionSum2,
        socialAwarenessSum1, setSocialAwarenessSum1,
        socialAwarenessSum2, setSocialAwarenessSum2,
        total,
        sortAnswers,

      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;